module.exports = __webpack_public_path__ + "static/media/logo.7d1aed2a.png";